import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { Security } from '@okta/okta-react';
import { AuthRootProvider } from './auth/AuthProvider';
import { ClearAnalysisCacheOnLogout } from './auth/ClearAnalysisCacheOnLogout';
import { oktaAuth } from './auth/oktaConfig';
import { ToastProvider } from './hooks/useToast';
import { router } from './router';
import './styles/tokens.css';
import './styles/reset.css';

const qc = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 15_000, retry: 1 },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Security
      oktaAuth={oktaAuth}
      restoreOriginalUri={async (_oa, originalUri) => {
        window.location.replace(originalUri || '/builders');
      }}
    >
      <QueryClientProvider client={qc}>
        <AuthRootProvider>
          <ClearAnalysisCacheOnLogout />
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </AuthRootProvider>
      </QueryClientProvider>
    </Security>
  </StrictMode>
);
